const ModifyNestedObjectFieldsStyles = () => ({
  container: {
    marginBottom: '20px',
    padding: '16px',
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
    backgroundColor: '#fafafa',
  },
  header: {
    marginBottom: '16px',
  },
  label: {
    marginBottom: '4px',
    fontWeight: 500,
  },
  helperText: {
    color: '#666',
    fontStyle: 'italic',
  },
  keysContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  accordion: {
    backgroundColor: '#fff',
    '&:before': {
      display: 'none',
    },
    '&.Mui-expanded': {
      margin: '0 !important',
    },
  },
  accordionSummary: {
    backgroundColor: '#f5f5f5',
    minHeight: '48px !important',
    '&.Mui-expanded': {
      minHeight: '48px !important',
    },
    '& .MuiAccordionSummary-content': {
      margin: '8px 0 !important',
    },
  },
  summaryContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    paddingRight: '8px',
  },
  keyName: {
    fontWeight: 500,
    fontFamily: 'monospace',
  },
  deleteButton: {
    color: '#d32f2f',
    '&:hover': {
      backgroundColor: 'rgba(211, 47, 47, 0.08)',
    },
  },
  accordionDetails: {
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
  },
  emptyState: {
    padding: '32px',
    textAlign: 'center',
    backgroundColor: '#fff',
    borderRadius: '4px',
    border: '1px dashed #ccc',
  },
  textField: {
    '& .MuiInputBase-root': {
      fontFamily: 'monospace',
    },
  },
});

export default ModifyNestedObjectFieldsStyles;
